import React from "react";

export default function Grid() {
  return {
    MuiGrid: {
      styleOverrides: {},
    },
  };
}
